import { generateId } from "../../../shared/utils/generateId";
import { TCreateCaseCommentBlock } from "../types";

export const createCaseCommentBlock = (): TCreateCaseCommentBlock => ({
  id: generateId(),
  author: "",
  comment: "",
});
